(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-media-modules"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-media-breakpoint-videos')) {
    customElements.define(
      'collection-media-breakpoint-videos',
      class CollectionMediaBreakpointVideos extends HTMLElement {
        connectedCallback() {
          this.desktopVideo = this.querySelector('.collection-media-modules__media--desktop');
          this.mobileVideo = this.querySelector('.collection-media-modules__media--mobile');
          if (!this.desktopVideo || !this.mobileVideo) return;

          this.mediaQuery = window.matchMedia('(min-width: 768px)');
          this.syncPlayback = this.syncPlayback.bind(this);
          this.mediaQuery.addEventListener('change', this.syncPlayback);
          this.syncPlayback();
        }

        disconnectedCallback() {
          if (this.mediaQuery) this.mediaQuery.removeEventListener('change', this.syncPlayback);
        }

        syncPlayback() {
          const showDesktop = this.mediaQuery.matches;
          this.activate(showDesktop ? this.desktopVideo : this.mobileVideo);
          this.deactivate(showDesktop ? this.mobileVideo : this.desktopVideo);
        }

        activate(video) {
          video.preload = 'metadata';
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        }

        deactivate(video) {
          video.pause();
          video.preload = 'none';
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
